$(function(){

  var i = 1,
      $abide = $('form.registration');
      $newC = $('li.price')[0], $priceAll = $('li.price.priceAll'),
      newCounter = $('li.price'),
      $counter = $('li.price')[0];
      //sendfeatsearcdata = [];

  var $box = $('select.sumobox');

  $box.SumoSelect({
    csvDispCount:             2,
    captionFormat:            '{0} kiválasztva',
    captionFormatAllSelected: 'Az összes kiválasztva!',
    placeholder:              $box.data('placeholder') || 'Válassz...',
    search:                   false,
    triggerChangeCombined:    true
  });

  if($abide.length) {
      // ------------------- CSAK HA REGISZTRÁCIO VAN ---------------------------------------------

      // A6   Helyszin / féléves
      // A12  Helyszin / egyéves
      // A424 Helyszin / kétéves

      // B6  egyéb / féléves
      // B12 egyéb / egyéves
      // B24 egyéb / kétéves

      var lastPrice = 0;

      function checkPrice() {
          var szolg, period, prices = {A: {6: 6500, 12: 16500, 24: 14500}, B: {6: 4000, 12: 4500, 24: 4000}},
              dd = _($('select[name="contract[contract_period]"], select[name="contract[payment_period]"], input[name="partner[category]"]:checked, #pp-connect')).map(function (el) {
                  if (el.name === "partner[category]")
                      return 1 < (v = _.toInteger(el.value)) ? 'B' : (v === 1 ? 'A' : null);
                  if (el.name === "contract[contract_period]")
                      return _.toInteger(el.value);
                  if (el.id === "pp-connect")
                      return el.checked && -0.1;
              }),
              price = _.get(prices, [(szolg = dd.filter(_.isString).first()), (period = dd.filter(_.isInteger).first())]);
          return [price + (price * (dd.indexOf(-0.1) > -1 ? -0.1 : 0)), period];
      }

      $('select[name="contract[contract_period]"], select[name="contract[payment_period]"], input[name="partner[category]"], #pp-connect').on('change', function (el) {
          var period, newprice, n = checkPrice();
          newprice = n[0], period = n[1]
          newCounter.removeClass('invalidPrice');
          if (newCounter[0]) {
              if (!newprice) {
                  newCounter.addClass('invalidPrice');
              }
              $priceAll.html('Összesen: ' + (_.toInteger(newprice) * _.toInteger(period)).cformat(' Ft') + ' + ÁFA');
          }
          //ccc = new CountUp($counter, _.toInteger(lastPrice), _.toInteger(newprice), 0, 2.7, settings.countup);
          ccc = new CountUp($counter, 6900, _.toInteger(newprice), 0, 2.7, settings.countup);
          ccc.start();
          lastPrice = newprice;
      }).trigger('change');

      $('#contacts').on('click', '.close-button', function (e) {
          $(this).closest('.addcontact[data-closable]').remove();
          var db = $('.addcontact').length;
          if (db < 5) $('.contactadd').removeClass('disabled');
          $('.counter').html(db < 2 ? '' : db);
          //Foundation.reInit($abide);
      });

      $('.contactadd').on('click', function addContact() {
          var db = $('.addcontact').length + 1;
          if (db > 5)
              return;
          var html = $('#addcontact').html().replace(/%count%/ig, $('#contacts .ccard').length);
          $('#contacts').append(initContentFields(html).fadeIn(1000, function () {
              $('.contactadd .counter').html(db);
              if (db >= 5) $('.contactadd').addClass('disabled');
              //Foundation.reInit($abide);
          }));
          i++;
      });

      $('form.registration .tabs-content [aria-hidden=true] input.req').removeAttr('required');
      $('form.registration').on('change.zf.tabs', '.tabs', function (e, $el) {
          if ($el instanceof jQuery) {
              $('input#companytype').val($el.data('companytype'));
              $('.tabs-content input.req', $abide).removeAttr('required').attr('disabled', true);
              $('.tabs-content .is-active input.req', $abide).attr('required', true).removeAttr('disabled');
              Foundation.reInit($abide);
          }
      });

  }
  var $billedit = $('form.bill-edit');
  if($billedit[0]) {
    $('form.bill-edit .tabs-content [aria-hidden=true] input.req').removeAttr('required').attr('disabled',true);
    $('form.bill-edit').on('change.zf.tabs', '.tabs', function(e, $el) {
        if($el instanceof jQuery) {
            //console.log($el);
            $('input#companytype').val($el.data('companytype'));
            $('.tabs-content input.req',$billedit).removeAttr('required').attr('disabled',true);
            $('.tabs-content .is-active input.req', $billedit).attr('required',true).removeAttr('disabled');
            Foundation.reInit($billedit);
        }
    });
  }


    // -----------------------------------------------------------------------------------------------

  $('.selectnew input[type=radio]').on('change', function(e){
    var $hide = $('.pricing-table .hide'),
        $checkd = $('input[name="partner[category]"]:checked'),
        bkg = $('+.circle',$checkd).css('background-image'),
        txt = $('~.partnername',$checkd).text();

    if($checkd.length && _.first(checkPrice())) {
      $('.partner .circle').css('background-image',bkg);
      $('.partner label>h6').text(txt);

      if($field = $('.custom-partner:not(:visible).hide')) {
        $field.removeClass('hide').fadeIn(500);
      }
    }
  }).trigger('change');

  $('.copyfinance').on('click', function() {
    $('.ccard.admin input').each(function() {
        name = 'input[name="'+($(this).attr('name') || '').replace('user', 'contacts[1]').replace('copy', '')+'"]';
        if($(this).val())
          $(name).val($(this).val());
        //console.log(name);
    });
  });

  $('.ccard.admin input#useremailsrc').on('keyup keypress change', function() {
    $('#useremailcc').val($(this).val());
  });

/// Találati igénylés ///

  $(".formorder .add").click(
    function(e){
      e.preventDefault();
      var
        form	= $(this).closest(".formorder"),
        $this = $(this),
        region = $(".region", form).val(),
        regionText = $(".region option:selected", form).text(),
        headcount = $(".headcount", form).val(),
        headcountText = $(".headcount option:selected", form).text(),
        yearmonth = _($(".yearmonth", form).val()).split('-'),
        yearmonthtext = _($(".yearmonth option:selected", form).text()).split(' '),
        year = yearText = yearmonth.first(),
        month = yearmonth.last(),
        monthText = yearmonthtext.last();

      var html =
        '<tr class="orderrow">' +
        '<td><input type="hidden" name="region[]" value="'+ region +'">' + regionText + '</td>' +
        '<td><input type="hidden" name="headcount[]" value="'+ headcount +'">' + headcountText + '</td>' +
        '<td><input type="hidden" name="year[]" value="'+ year +'">' + yearText + '</td>' +
        '<td><input type="hidden" name="month[]" value="'+ month +'">' + monthText + '</td>' +
        '<td><a href="#" class="remove">Eltávolít</a></td>' +
        '</tr>';
      $(".listcontainer", form).append(html);
    }
  );

  $(".sysformorder .add").click(
    function(e){
      e.preventDefault();
        var
          form	= $(this).closest(".sysformorder"),
          $this = $(this),
          deal = $(".deals", form).val(),
          dealText = $(".deals option:selected", form).text(),
          paidornot = $(".paidornot", form).val(),
          paidornotText = $(".paidornot option:selected", form).text(),
          mainorcat = $(".mainorcat", form).val(),
          mainorcatText = $(".mainorcat option:selected", form).text(),
          type = $(".type", form).val(),
          typeText = $(".type option:selected", form).text(),
          region = $(".region", form).val(),
          regionText = $(".region option:selected", form).text(),
          headcount = $(".headcount", form).val(),
          headcountText = $(".headcount option:selected", form).text(),
          dateon = $(".dateon", form).val(),
          dateoff = $(".dateoff", form).val();

      if(deal) {
        var html =
          '<tr class="orderrow">' +
          '<td><input type="hidden" name="deal[]" value="'+ deal +'">' + dealText + '</td>' +
          '<td><input type="hidden" name="paidornot[]" value="'+ paidornot +'">' + paidornotText + '</td>' +
          '<td><input type="hidden" name="mainorcat[]" value="'+ mainorcat +'">' + mainorcatText + '</td>' +
          '<td><input type="hidden" name="type[]" value="'+ type +'">' + typeText + '</td>' +
          '<td><input type="hidden" name="dateon[]" value="'+ dateon +'">' + dateon + '</td>' +
          '<td><input type="hidden" name="dateoff[]" value="'+ dateoff +'">' + dateoff + '</td>' +
          '<td><a href="#" class="remove">Eltávolít</a></td>' +
          '</tr>';
        $(".listcontainer", form).append(html);
      }
      else {
        var html2 =
          '<tr class="orderrow">' +
          '<td><input type="hidden" name="paidornot[]" value="'+ paidornot +'">' + paidornotText + '</td>' +
          '<td><input type="hidden" name="mainorcat[]" value="'+ mainorcat +'">' + mainorcatText + '</td>' +
          '<td><input type="hidden" name="type[]" value="'+ type +'">' + typeText + '</td>' +
          '<td><input type="hidden" name="region[]" value="'+ region +'">' + regionText + '</td>' +
          '<td><input type="hidden" name="headcount[]" value="'+ headcount +'">' + headcountText + '</td>' +
          '<td><input type="hidden" name="dateon[]" value="'+ dateon +'">' + dateon + '</td>' +
          '<td><input type="hidden" name="dateoff[]" value="'+ dateoff +'">' + dateoff + '</td>' +
          '<td><a href="#" class="remove">Eltávolít</a></td>' +
          '</tr>';
        $(".listcontainer", form).append(html2);
      }
    }
  );

  $(".listcontainer").delegate(".remove", "click", function(e){
    e.preventDefault();
    $(this).closest(".orderrow").remove();
  });


  $('.personadd-button').click(function(e) {
    var partnerid = $(this).data('partnerid'),
      type = $(this).data('type');
    $('#personadd .partner_id').val(partnerid);
    $('#personadd .person_type').val(type);
    $('#personadd').foundation('open');
  });

  $('.personmod-button').click(function(e) {
    var personid = $(this).data('personid'),
        partnerid = $(this).data('partnerid'),
        type = $(this).data('person_type'),
        firstname = $(this).data('firstname'),
        forename = $(this).data('forename'),
        name = $(this).data('name'),
        phone = $(this).data('phone'),
        mobile = $(this).data('mobile'),
        email = $(this).data('email');
    $('#personmod .personid').val(personid);
    $('#personmod .partner_id').val(partnerid);
    $('#personmod .type').val(type);
    $('#personmod .firstname').val(firstname);
    $('#personmod .forename').val(forename);
    $('#personmod .name').val(name);
    $('#personmod .phone').val(phone);
    $('#personmod .mobile').val(mobile);
    $('#personmod .email').val(email);
    $('#personmod').foundation('open');
  });
});
